/** A grid of closed-choice buttons: the visit outcome, or the door constat. */
export interface OutcomeChoiceOption<T extends string> {
  value: T;
  label: string;
}

export interface OutcomeChoiceProps<T extends string> {
  options: OutcomeChoiceOption<T>[];
  value: T | null;
  onChange: (value: T) => void;
  ariaLabel: string;
  disabled?: boolean;
}

/**
 * Render a two-column grid of mutually-exclusive choice buttons, the way
 * `docs/maquettes/prototype-terrain.html`'s `.choix` renders "Résultat de la
 * visite" and the registration door's "Constat".
 *
 * @param props - The options, the selected value, and a change handler.
 * @returns The choice grid element.
 */
export function OutcomeChoice<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  disabled = false,
}: OutcomeChoiceProps<T>) {
  return (
    <div className="choix" role="group" aria-label={ariaLabel}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={value === option.value ? 'on' : ''}
          aria-pressed={value === option.value}
          onClick={() => onChange(option.value)}
          disabled={disabled}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
